import React, { useState, useEffect } from 'react';
import { Layers, Package, Calendar } from 'lucide-react';

import { useToast } from '../hooks/useToast';
// import { AssetCategoryManager } from './AssetCategoryManager';
import { AssetCategoryManager } from './AssetCategoryManager';
import { FixedAssetRegistration } from './FixedAssetRegistration';
import { DepreciationPostingConsole } from './DepreciationPostingConsole';

const TABS = [
    { id: 'register', label: 'Asset Register', icon: Package },
    { id: 'categories', label: 'Asset Categories & GL', icon: Layers },
    { id: 'depreciation', label: 'Depreciation Execution', icon: Calendar },
];

const FixedAssetsDashboard = () => {
    const { showToast } = useToast();
    const [user, setUser] = useState(null);
    const [activeTab, setActiveTab] = useState('register');

    useEffect(() => {
        const stored = localStorage.getItem('user');
        const org_id = localStorage.getItem('org_id')
        if (stored) {
            const activeUser = {...JSON.parse(stored), org_id}
            // console.log(activeUser)
            setUser(activeUser);
        } else {
            showToast("Please log in to manage Fixed Assets.", "info");
        }
    }, [showToast]);

    return (
        <div className="max-w-7xl mx-auto px-4 py-0 space-y-6">
            <div className="border-b border-zinc-200 pb-4">
                <h1 className="text-2xl font-bold tracking-tight text-zinc-900">Fixed Asset Accounting (IAS 16)</h1>
                <p className="text-xs text-zinc-500 mt-1">
                    Manage capital asset lifecycles, asset categorization, automated GL mappings, and depreciation postings.
                </p>
            </div>

            {/* Sub-module Navigation */}
            <div className="flex border-b border-zinc-200 space-x-2">
                {TABS.map((tab) => {
                    const Icon = tab.icon;
                    const isActive = activeTab === tab.id;
                    return (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`flex items-center gap-2 px-4 py-2.5 text-xs font-semibold border-b-2 transition-all ${isActive
                                    ? 'border-indigo-600 text-indigo-600 bg-indigo-50/50'
                                    : 'border-transparent text-zinc-500 hover:text-zinc-800 hover:border-zinc-300'
                                }`}
                        >
                            <Icon size={16} />
                            {tab.label}
                        </button>
                    );
                })}
            </div>

            {/* Context Render */}
            <div className="pt-2">
                {activeTab === 'register' && <FixedAssetRegistration currentUser={user} />}
                {activeTab === 'categories' && <AssetCategoryManager currentUser={user} />}
                {activeTab === 'depreciation' && <DepreciationPostingConsole currentUser={user} />}
            </div>
        </div>
    );
};

export default FixedAssetsDashboard;